import { render, staticRenderFns } from "./PDF_Upload.vue?vue&type=template&id=063e8926&scoped=true"
import script from "./PDF_Upload.vue?vue&type=script&lang=js"
export * from "./PDF_Upload.vue?vue&type=script&lang=js"
import style0 from "./PDF_Upload.vue?vue&type=style&index=0&id=063e8926&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063e8926",
  null
  
)

export default component.exports